
export const paymentMenuDef = [
    {
        name: 'menu.payment',
        icon: 'fa fa-key',
        data: {
            nav_url: "deposit_m"
        },
        children: [
            {
                resource: 'opItemConsumptionCardLayout',
                icon: 'icons.application.user',
                url: 'opItemConsumptionCardLayout',
                auto_crud: true,
                check_permission: false
            },
            {
                "resource": "paymant_transaction_history",
                "url": "paymant_transaction_history",
                "auto_crud": true,
                "check_permssion": false
            },
            {
                "resource": "convert_uhid_advance",
                "url": "convert_uhid_advance",
                "auto_crud": true
            },
            {
                "resource": "package_multiple_payment",
                "url": "package_multiple_payment",
                "auto_crud": true,
                "check_permssion": false
            },
            {
                name: "menu.ip_advance",
                resource: "ipAdvance_format",
                icon: "fa fa-user",
                url: "ipAdvance_format",
                auto_crud: true,
                check_permission: false
            },
            {
                name: "menu.ip_advance",
                resource: "optical_advance_format",
                icon: "fa fa-user",
                url: "optical_advance_format",
                auto_crud: true,
                check_permission: false
            },
            {
                name: "menu.er_advance",
                resource: "erAdvance_format",
                icon: "fa fa-user",
                url: "erAdvance_format",
                auto_crud: true,
                check_permission: false
            },
            {
                name: "menu.er_advance",
                resource: "equipment",
                icon: "fa fa-user",
                url: "equipment",
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.custom_collection_format',
                resource: 'custom_collection_format',
                icon: 'fa fa-user',
                application: 'payment',
                url: 'custom_collection_format',
                auto_crud: true,
                check_permission: false,
                showMenu: false
            },
            {
                name: "menu.dc_advance",
                resource: "dcAdvance_format",
                icon: "fa fa-user",
                url: "dcAdvance_format",
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.deposit_admissionId',
                resource: 'deposit_admissionId',
                icon: 'fa fa-user',
                url: 'deposit_admissionId',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.general_voucher',
                resource: "general_voucher",
                icon: 'fa fa-square',
                url: 'general_voucher',
                check_permission: false,
                auto_crud: true,
                showMenu: true
              },
              {
                "name": 'menu.sponsor_fund',
                "resource": 'sponsor_fund',
                "url": 'sponsor_fund',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": "menu.auto_consultation",
                "resource": "auto_consultation",
                "icon": "fa fa-tag",
                "url": "auto_consultation",
                "auto_crud": true,
                "breadcrumb": "Auto Consultation"
              },
              {
                "name": 'menu.sponsor_fund_tabs',
                "resource": 'sponsor_fund_tabs',
                "url": 'sponsor_fund_tabs',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": 'menu.sponsor_p_mgmnt',
                "resource": 'sponsor_p_mgmnt',
                "url": 'sponsor_p_mgmnt',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": 'menu.sponsor_received_amount',
                "resource": 'sponsor_received_amount',
                "url": 'sponsor_received_amount',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": 'menu.sponser_patient_reveived',
                "resource": 'sponser_patient_reveived',
                "url": 'sponser_patient_reveived',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": 'menu.sponsor_fund_refund',
                "resource": 'sponsor_fund_refund',
                "url": 'sponsor_fund_refund',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": 'menu.sponsor_patient_topup',
                "resource": 'sponsor_patient_topup',
                "url": 'sponsor_patient_topup',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund',
                "showMenu": true
              },
              {
                "name": 'menu.sponsor_fund_ledger',
                "resource": 'sponsor_fund_ledger',
                "url": 'sponsor_fund_ledger',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Fund Ledger',
                "showMenu": true 
              },
              {
                "name": 'menu.sponsored_patient_ledger',
                "resource": 'sponsored_patient_ledger',
                "url": 'sponsored_patient_ledger',
                "auto_crud": true,
                "breadcrumb": 'Sponsor Patient Ledger',
                "showMenu": true 
              },
              {
                "name": 'menu.sponsor_refund_ptnt',
                "resource": 'sponsor_refund_ptnt',
                "url": 'sponsor_refund_ptnt',
                "auto_crud": true,
                "breadcrumb": 'Refund',
                "showMenu": true 
              },
              {
                "name": 'menu.sponsor_refund_management',
                "resource": 'sponsor_refund_management',
                "url": 'sponsor_refund_management',
                "auto_crud": true,
                "breadcrumb": 'Refund',
                "showMenu": true 
              },
              {
                name : "menu.user_wise_general_payment",
                resource: "user_wise_general_payment",
                url: 'user_wise_general_payment',
                "auto_crud": true,
              },
              {
                name : "menu.user_wise_general_receipt",
                resource: "user_wise_general_receipt",
                url: 'user_wise_general_receipt',
                "auto_crud": true,
              },
              {
                name : "menu.general_payment_receipt_details",
                resource: "general_payment_receipt_details",
                url: 'general_payment_receipt_details',
                "auto_crud": true,
              },
            {
                name: 'menu.deposit',
                resource: 'deposit',
                view: 'patient_deposit',
                icon: 'fa fa-tag',
                url: 'deposit_patient',
                auto_crud: true,
                showMenu: false,
            },
            {
                name: 'menu.deposit_uhId',
                resource: 'deposit_uhId',
                icon: 'fa fa-user',
                url: 'deposit_uhId',
                auto_crud: true,
                breadcrumb: 'Deposit_uhId',
                showMenu: false
            },
            {
                name: 'menu.uhid_advance_on_hold',
                resource: 'deposit_uhId_on_hold',
                icon: 'fa fa-user',
                url: 'deposit_uhId_on_hold',
                auto_crud: true,
                breadcrumb: 'Deposit_uhId',
                showMenu: false
            },
            {
                name: 'menu.payer_deposit_advance',
                resource: 'payer_deposit_advance',
                icon: 'fa fa-user',
                url: 'payer_deposit_advance',
                auto_crud: true,
                breadcrumb: 'Payer Deposit',
                showMenu: false
            },
            {
                name: 'menu.insurance_deposit_advance',
                resource: 'insurance_deposit_advance',
                icon: 'fa fa-user',
                url: 'insurance_deposit_advance',
                auto_crud: true,
                breadcrumb: 'Insurance Deposit',
                showMenu: false
            },
            {
                name: 'menu.deposit_orderId',
                resource: 'deposit_orderId',
                icon: 'fa fa-user',
                url: 'deposit_orderId',
                auto_crud: true,
                breadcrumb: 'Deposit_orderId',
                showMenu: false
            },
            {
                name: 'menu.refund',
                resource: 'refund',
                icon: 'fa fa-user',
                url: 'refund',
                auto_crud: true,
                breadcrumb: 'Refund',
                check_permission: false,
            },
            {
                name: 'menu.refund_insurance',
                resource: 'refund_insurance',
                icon: 'fa fa-user',
                url: 'refund_insurance',
                auto_crud: true,
                breadcrumb: 'Refund Insurance',
                check_permission: false,
            },
            {
                name: 'menu.refund_payer',
                resource: 'refund_payer',
                icon: 'fa fa-user',
                url: 'refund_payer',
                auto_crud: true,
                breadcrumb: 'Refund Payer',
                check_permission: false,
            },
            {
                name: 'menu.refund_deposit_uhId',
                resource: 'refund_deposit_uhId',
                icon: 'fa fa-user',
                url: 'refund_deposit_uhId',
                auto_crud: true,
                breadcrumb: 'Refund Deposit for uhId',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.refund_deposit_insurance',
                resource: 'refund_deposit_insurance',
                icon: 'fa fa-user',
                url: 'refund_deposit_insurance',
                auto_crud: true,
                breadcrumb: 'Refund Deposit for insurance',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.refund_deposit_payer',
                resource: 'refund_deposit_payer',
                icon: 'fa fa-user',
                url: 'refund_deposit_payer',
                auto_crud: true,
                breadcrumb: 'Refund Deposit for payer',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.refund_deposit_optical',
                resource: 'refund_deposit_optical',
                icon: 'fa fa-user',
                url: 'refund_deposit_optical',
                auto_crud: true,
                breadcrumb: 'Refund Deposit for Optical',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.op_billing_add_remarks',
                resource: 'op_billing_add_remarks',
                icon: 'fa fa-user',
                url: 'op_billing_add_remarks',
                auto_crud: true,
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.refund_deposit_orderId',
                resource: 'refund_deposit_orderId',
                icon: 'fa fa-user',
                url: 'refund_deposit_orderId',
                auto_crud: true,
                breadcrumb: 'Refund Deposit for uhId',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.refund_deposit_admissionId',
                resource: 'refund_deposit_admissionId',
                icon: 'fa fa-user',
                url: 'refund_deposit_admissionId',
                auto_crud: true,
                breadcrumb: 'Refund Deposit for AdmissionId',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.due_settlement',
                resource: 'due_settlement',
                icon: 'fa fa-user',
                url: 'due_settlement',
                auto_crud: true,
                breadcrumb: 'Due'
            },
            {
                name: 'menu.advance_details',
                resource: 'deposit_wallet',
                icon: 'fa fa-user',
                url: 'deposit_wallet',
                auto_crud: true,
                breadcrumb: 'Advance Details',
                check_permission: false,
            },
            {
                name: 'menu.consumed_details',
                resource: 'deposit_consumed_details',
                icon: 'fa fa-user',
                url: 'deposit_consumed_details',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
            },
            {
                name: 'menu.consumed_details',
                resource: 'consumed_details_deposit_ip',
                icon: 'fa fa-user',
                url: 'consumed_details_deposit_ip',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
            },
            {
                name: 'menu.consumed_details',
                resource: 'consumed_details_deposit',
                icon: 'fa fa-user',
                url: 'consumed_details_deposit',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
                showMenu: false
            },
            // ticket 201175 : payment mode wise receipt grids (opened from three dot, hidden in menu)
            {
                name: 'menu.payment_mode_wise_receipt',
                resource: 'payment_mode_wise_receipt_deposit',
                icon: 'fa fa-user',
                url: 'payment_mode_wise_receipt_deposit',
                auto_crud: true,
                breadcrumb: 'Payment Mode Wise Receipt',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.payment_mode_wise_receipt',
                resource: 'payment_mode_wise_receipt_settlement',
                icon: 'fa fa-user',
                url: 'payment_mode_wise_receipt_settlement',
                auto_crud: true,
                breadcrumb: 'Payment Mode Wise Receipt',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.payment_mode_wise_receipt',
                resource: 'payment_mode_wise_receipt_refund_op',
                icon: 'fa fa-user',
                url: 'payment_mode_wise_receipt_refund_op',
                auto_crud: true,
                breadcrumb: 'Payment Mode Wise Receipt',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.payment_mode_wise_receipt',
                resource: 'payment_mode_wise_receipt_refund_ip',
                icon: 'fa fa-user',
                url: 'payment_mode_wise_receipt_refund_ip',
                auto_crud: true,
                breadcrumb: 'Payment Mode Wise Receipt',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.payment_mode_wise_receipt',
                resource: 'payment_mode_wise_receipt_refund_bill',
                icon: 'fa fa-user',
                url: 'payment_mode_wise_receipt_refund_bill',
                auto_crud: true,
                breadcrumb: 'Payment Mode Wise Receipt',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.consumed_details',
                resource: 'consumed_details_orderid',
                icon: 'fa fa-user',
                url: 'consumed_details_orderid',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.consumed_details',
                resource: 'consumed_details_wallet',
                icon: 'fa fa-user',
                url: 'consumed_details_wallet',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.settlement',
                resource: 'settlement',
                icon: 'fa fa-user',
                url: 'settlement',
                auto_crud: true,
                breadcrumb: 'Settlement'
            },
            {
                name: 'menu.open_bill',
                resource: 'open_bill',
                icon: 'fa fa-user',
                url: 'open_bill',
                auto_crud: true,
                breadcrumb: 'Open Bill'
            },
            {
                name: 'menu.split_bills',
                resource: 'split_bills',
                icon: 'fa fa-user',
                url: 'split_bills',
                auto_crud: true,
                breadcrumb: 'Split Bills'
            },
            {
                name: 'menu.split_return',
                resource: 'split_return',
                icon: 'fa fa-user',
                url: 'split_return',
                auto_crud: true,
                breadcrumb: 'Split Return'
            },
            {
                name: 'menu.settlement_op',
                resource: 'completedBills',
                icon: 'fa fa-user',
                url: 'completedBills',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.opBilling',
                resource: 'opbilling_format',
                icon: 'fa fa-plus-square',
                url: 'opbilling_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: "menu.service_request",
                resource: "service_request",
                icon: "fa fa-user",
                url: "service_request",
                auto_crud: true,
                showMenu: false
            },
            {
                name: "menu.advance_op",
                resource: "advance_op",
                icon: "fa fa-user",
                url: "advance_op",
                auto_crud: true,
                showMenu: false
            },
            {
                name: "menu.refund_op",
                resource: "refund_op",
                icon: "fa fa-user",
                url: "refund_op",
                auto_crud: true,
                showMenu: false
            },
            {
                name: "menu.optical_deposit",
                "resource": "optical_deposit",
                url: "optical_deposit",
                auto_crud: true,
                check_permission: false
            },
            {
                name: "menu.refund_optical",
                resource: "refund_optical",
                icon: "fa fa-user",
                url: "refund_optical",
                auto_crud: true,
                showMenu: false
            },
            {
                name: "menu.refund_op_orderId",
                resource: "refurefund_op_orderIdnd_op",
                icon: "fa fa-user",
                url: "refund_op_orderId",
                auto_crud: true,
                showMenu: false
            },
            {
                name: "menu.refund_op",
                resource: "payment_order_details",
                icon: "fa fa-user",
                url: "payment_order_details",
                auto_crud: true,
                showMenu: false
            },
            {
                name: "User Collection Summary",
                resource: "user_collection_summary_old",
                icon: "fa fa-user",
                url: "user_collection_summary",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "User Collection Summary",
                resource: "user_collection_summary",
                icon: "fa fa-user",
                url: "user_collection_summaryv1",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "Custom User Collection Summary",
                resource: "custom_user_collection_summary_details",
                icon: "fa fa-user",
                url: "custom_user_collection_summary_details",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "User Collection Detail",
                resource: "user_collection_detail_old",
                icon: "fa fa-user",
                url: "user_collection_detail",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "User Collection Detail",
                resource: "user_collection_detail",
                icon: "fa fa-user",
                url: "user_collection_detailv1",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "Cashier Collection Detail",
                resource: "cashier_collection_detail_old",
                icon: "fa fa-user",
                url: "cashier_collection_detail",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "Cashier Collection Detail",
                resource: "cashier_collection_detail",
                icon: "fa fa-user",
                url: "cashier_collection_detailv1",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "Cashier Collection",
                resource: "cashier_collection",
                icon: "fa fa-user",
                url: "cashier_collection",
                auto_crud: false,
                showMenu: true
            },
            {
                name: "Cashier Collection_detail",
                resource: "cashier_collection_detail",
                icon: "fa fa-user",
                url: "cashier_collection_detail",
                auto_crud: false,
                showMenu: true
            },
            {
                name: 'menu.uhid_advance_format',
                resource: 'uhid_advance_format',
                icon: 'fa fa-plus-square',
                url: 'uhid_advance_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.orderid_advance_format',
                resource: 'orderid_advance_format',
                icon: 'fa fa-plus-square',
                url: 'orderid_advance_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.collection_detail_format_old',
                resource: 'collection_detail_format_old',
                icon: 'fa fa-user',
                application: 'payment',
                url: 'collection_detail_format_old',
                auto_crud: true,
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.collection_detail_format',
                resource: 'collection_detail_format',
                icon: 'fa fa-user',
                application: 'payment',
                url: 'collection_detail_format',
                auto_crud: true,
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.advance_approve',
                resource: 'advance_approve',
                icon: 'fa fa-user',
                application: 'payment',
                url: 'advance_approve',
                auto_crud: true,
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.ip_settlement_format',
                resource: 'ip_settlement_format',
                icon: 'fa fa-plus-square',
                url: 'ip_settlement_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.dc_settlement_format',
                resource: 'dc_settlement_format',
                icon: 'fa fa-plus-square',
                url: 'dc_settlement_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.er_settlement_format',
                resource: 'er_settlement_format',
                icon: 'fa fa-plus-square',
                url: 'er_settlement_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.settlement_pending',
                resource: 'settlement_pending',
                icon: 'fa fa-plus-square',
                url: 'settlement_pending',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.deposit',
                resource: 'deposit',
                icon: 'fa fa-plus-square',
                url: 'deposit',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.due_settlement_op',
                resource: 'due_settlement_op',
                icon: 'fa fa-plus-square',
                url: 'due_settlement_op',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.due_settlement_billing',
                resource: 'due_settlement_billing',
                icon: 'fa fa-plus-square',
                url: 'due_settlement_billing',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.deposit_admissionId_er',
                resource: 'deposit_admissionId_er',
                icon: 'fa fa-user',
                url: 'deposit_admissionId_er',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.deposit_admissionId_er',
                resource: 'requested_orders_prescription',
                icon: 'fa fa-user',
                url: 'requested_orders_prescription',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.deposit_admissionId_dc',
                resource: 'deposit_admissionId_dc',
                icon: 'fa fa-user',
                url: 'deposit_admissionId_dc',
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.consumed_details',
                resource: 'deposit_consumed_details_op',
                icon: 'fa fa-user',
                url: 'deposit_consumed_details_op',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
            },
            {
                name: 'menu.consumed_details',
                resource: 'insurance_consumed_details_view',
                icon: 'fa fa-user',
                url: 'insurance_consumed_details_view',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
            },
            {
                name: 'menu.consumed_details',
                resource: 'payer_consumed_details_view',
                icon: 'fa fa-user',
                url: 'payer_consumed_details_view',
                auto_crud: true,
                breadcrumb: 'Deposit Consumed Details',
                check_permission: false,
            },
            {
                name: 'menu.advance_details',
                resource: "ip_uhid_advance",
                icon: 'fa fa-h-square',
                url: 'ip_uhid_advance',
                check_permission: false,
                auto_crud: true,
                showMenu: true
              },
            {
                name: 'menu.advance_details',
                resource: 'deposit_wallet_op',
                icon: 'fa fa-user',
                url: 'deposit_wallet_op',
                auto_crud: true,
                breadcrumb: 'Advance Details',
                check_permission: false,
            },
            {
                name: 'menu.dispatchedBill_tab',
                resource: 'dispatchedBill_tab',
                icon: 'icons.application.user',
                url: 'dispatchedBill_tab',
                auto_crud: true,
                breadcrumb: 'Dispatched Bills',
                check_permission: false
            },
            // {
            //     name: 'menu.dispatched_bills',
            //     resource: 'dispatched_bills',
            //     icon: 'fa fa-user',
            //     url: 'dispatched_bills',
            //     auto_crud: true,
            //     breadcrumb: 'Dispatched Bills',
            //     check_permission: false,
            // },
            {
                name: 'menu.dispatched_bills_form',
                resource: 'dispatched_bills_form',
                icon: 'fa fa-user',
                url: 'dispatched_bills_form',
                auto_crud: true,
                breadcrumb: 'Individual Dispatched Bills Form',
                check_permission: false,
            },
            {
                name: 'menu.bulk_dispatched_bills_form',
                resource: 'bulk_dispatched_bills_form',
                icon: 'fa fa-user',
                url: 'bulk_dispatched_bills_form',
                auto_crud: true,
                breadcrumb: 'Bulk Dispatched Bills Form',
                check_permission: false,
            },
            {
                name: 'menu.dispatchedBills_tab',
                resource: 'dispatchedBills_tab',
                icon: 'fa fa-user',
                url: 'dispatchedBills_tab',
                auto_crud: true,
                breadcrumb: 'Dispatched Bills Tab',
                check_permission: false,
            },
            {
                name: 'menu.outstandingDetail_tab',
                resource: 'outstandingDetail_tab',
                icon: 'icons.application.user',
                url: 'outstandingDetail_tab',
                auto_crud: true,
                breadcrumb: 'Outstanding History',
                check_permission: false
            },
            // {
            //     name: 'menu.outstanding_details',
            //     resource: 'outstanding_details',
            //     icon: 'fa fa-user',
            //     url: 'outstanding_details',
            //     auto_crud: true,
            //     breadcrumb: 'Outstanding Details',
            //     check_permission: false,
            // },
            // {
            //     name: 'menu.outstanding_summary',
            //     resource: 'outstanding_summary',
            //     icon: 'fa fa-user',
            //     url: 'outstanding_summary',
            //     auto_crud: true,
            //     breadcrumb: 'Outstanding Summary',
            //     check_permission: false,
            // },
            {
                name: 'menu.deductionDetail_tab',
                resource: 'deductionDetail_tab',
                icon: 'icons.application.user',
                url: 'deductionDetail_tab',
                auto_crud: true,
                breadcrumb: 'Deduction History',
                check_permission: false
            },
            // {
            //     name: 'menu.deduction_details',
            //     resource: 'deduction_details',
            //     icon: 'fa fa-user',
            //     url: 'deduction_details',
            //     auto_crud: true,
            //     breadcrumb: 'Deduction Details',
            //     check_permission: false,
            // },
            // {
            //     name: 'menu.deduction_summary',
            //     resource: 'deduction_summary',
            //     icon: 'fa fa-user',
            //     url: 'deduction_summary',
            //     auto_crud: true,
            //     breadcrumb: 'Deduction Summary',
            //     check_permission: false,
            // }
            // {
            //     name: 'menu.bulkSettlement',
            //     resource: 'bulkSettlement',
            //     icon: 'fa fa-user',
            //     url: 'bulkSettlement',
            //     auto_crud: false,
            //     breadcrumb: 'Bulk Settlement',
            //     check_permission:false
            // }
            {
                name: 'menu.payer_advance_format',
                resource: 'payer_advance_format',
                icon: 'fa fa-user',
                url: 'payer_advance_format',
                auto_crud: true,
                breadcrumb: 'Payer Advance',
                check_permission: false
            },
            {
                name: 'menu.insurance_advance_format',
                resource: 'insurance_advance_format',
                icon: 'fa fa-user',
                url: 'insurance_advance_format',
                auto_crud: true,
                breadcrumb: 'Payer Advance',
                check_permission: false
            },
            {
                name: 'menu.parking_advance_format',
                resource: 'parking_advance_format',
                icon: 'fa fa-user',
                url: 'parking_advance_format',
                auto_crud: true,
                breadcrumb: 'Parking Deposit',
                check_permission: false
            },
            {
                name: 'menu.parking_deposit_advance',
                resource: 'parking_deposit_advance',
                icon: 'fa fa-user',
                url: 'parking_deposit_advance',
                auto_crud: true,
                breadcrumb: 'Parking Deposit',
                showMenu: false
            },
            {
                name: 'menu.parking_consumed_details_view',
                resource: 'parking_consumed_details_view',
                icon: 'fa fa-user',
                url: 'parking_consumed_details_view',
                auto_crud: true,
                breadcrumb: 'Parking Consumed Details',
                showMenu: false
            },
            {
                name: 'menu.parking_deposit_refund',
                resource: 'parking_deposit_refund',
                icon: 'fa fa-user',
                url: 'parking_deposit_refund',
                auto_crud: true,
                breadcrumb: 'Parking Deposit Refund',
                showMenu: false
            },
            {
                name: 'menu.arSettlement_tab',
                resource: 'arSettlement_tab',
                icon: 'fa fa-user',
                url: 'arSettlement_tab',
                auto_crud: true,
                breadcrumb: 'AR Settlement',
                check_permission: false
            },
            {
                name: 'menu.service_request_item_wise',
                resource: 'service_request_item_wise',
                icon: 'fa fa-user',
                url: 'service_request_item_wise',
                auto_crud: true,
                breadcrumb: 'Booked Orders',
                check_permission: false
            },
            {
                name: 'menu.hie_eligibility_history_tab',
                resource: 'hie_eligibility_history_tab',
                icon: 'fa fa-user',
                url: 'hie_eligibility_history_tab',
                auto_crud: true,
                breadcrumb: 'Booked Orders',
                check_permission: false
            },
            {
                name: 'menu.payment_gateway_details',
                resource: 'payment_gateway_details',
                icon: 'fa fa-user',
                url: 'payment_gateway_details',
                auto_crud: true,
                breadcrumb: 'Payment Gateway Detail',
                check_permission: false
            },
            {
                name: 'menu.service_request_item_wise',
                resource: 'service_request_draft',
                icon: 'fa fa-user',
                url: 'service_request_draft',
                auto_crud: true,
                breadcrumb: 'Draft Orders',
                check_permission: false
            },
            {
                name: 'menu.deposit',
                resource: 'deposit_optical_admissionId',
                icon: 'fa fa-tag',
                url: 'deposit_optical_admissionId',
                auto_crud: true,
                showMenu: false,
                check_permission: false
            },
            {
                name: "Mis Pending Bills",
                resource: "mis_pending_bills",
                icon: "fa fa-user",
                url: "mis_pending_bills",
                auto_crud: false,
                showMenu: true,
                check_permission: false
            },
            {
                name: 'menu.item_consumption_view',
                icon: 'fa fa-h-square',
                resource: 'item_consumption_completed_view',
                url: 'item_consumption_completed_view',
                auto_crud: true,
                check_permission: false,
            },
            {
                name: 'menu.item_consumption_view',
                icon: 'fa fa-h-square',
                resource: 'item_consumption_cancelled_view',
                url: 'item_consumption_cancelled_view',
                auto_crud: true,
                check_permission: false,
            },
            {
                name: 'menu.requested_order_format',
                resource: 'requested_order_format',
                icon: 'fa fa-plus-square',
                url: 'requested_order_format',
                auto_crud: true,
                check_permission: false
            },
            {
                name: 'menu.eligibility_form',
                resource: 'eligibility_form',
                icon: 'fa fa-plus-square',
                url: 'eligibility_form',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.authorization_form',
                resource: 'op_authorization',
                icon: 'fa fa-plus-square',
                url: 'op_authorization',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.sponsor_refund',
                resource: 'sponsor_refund',
                icon: 'fa fa-user',
                url: 'sponsor_refund',
                auto_crud: true,
                breadcrumb: 'Sponsor Refund',
                check_permission: false,
                showMenu: false
            },
            {
                name: 'menu.appointment_review_visit',
                resource: 'appointment_review_visit',
                icon: 'fa fa-user',
                url: 'appointment_review_visit',
                auto_crud: true,
                breadcrumb: 'Appointment Review Visit',
                check_permission: false,
                showMenu: false
            },
            {
                "name": "menu.op_view_authorization",
                "resource": "op_view_authorization",
                "icon": "fa fa-user",
                "url": "op_view_authorization",
                "auto_crud": true,
                "breadcrumb": "Discharged Patients",
                check_permission: false,
                "showMenu": false
            },
            {
                name: 'menu.direct_authorization',
                resource: 'direct_authorization',
                icon: 'fa fa-plus-square',
                url: 'direct_authorization',
                check_permission: false,
                auto_crud: true,
                breadcrumb: 'HIE Authorization',
                showMenu: true
            },
            { 
                name: 'menu.pharmacy_authorization',
                resource: 'pharmacy_authorization',
                icon: 'fa fa-plus-square',
                url: 'pharmacy_authorization',
                check_permission: false,
                auto_crud: true,
                breadcrumb: 'HIE Authorization',
                showMenu: true
            },
            {
                "name": "menu.cash_denomination",
                "resource": "cash_denomination",
                "icon": "fa fa-user",
                "url": "cash_denomination",
                "auto_crud": true,
                "breadcrumb": "Discharged Patients",
                check_permission: false,
                "showMenu": false
            }
        ]
    }
]